!(
  function() {
    const style_template = `
<style>
.content-author-button {
  right: -114px;
  display: block;
  font-family: Roboto,Arial;
  height: 30px;
  line-height: 30px;
  position: fixed;
  top: 50%;
  color: #fff;
  text-align: center;
  vertical-align: middle;
  -webkit-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  transform: rotate(90deg);
  -webkit-transition: all .5s;
  transition: all .5s;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
  letter-spacing: .2rem;
  padding-left: 5px;
  padding-right: 5px;
  -webkit-font-smoothing: antialiased;
  -webkit-text-shadow: rgba(0,0,0,.01) 0 0 1px;
  z-index: 9999;
}

.content-author-button ul {
  display: flex;
}

.content-author-button ul li:first-child {
  background: green;
}

.content-author-button ul li {
  background: grey;
  padding: 0 10px;
}

.content-author-button ul a {
  color: white;
}
</style>`;

    const button_template = `<div class='content-author-button'>
    <ul>
    <li>
        <a href="/wp-admin" id="author_admin_link">WP-Admin</a>
    </li>
    <li>
        <a href="/wp-admin/post.php?post={{post_id}}&action=edit" id="author_edit_link">Bearbeiten</a>
    </li>
    </ul>
</div>`;

    const set_admin_links = () => {
      const postId = window.uwpac.post_id;

      if ( !postId ) {
        return;
      }

      const div = document.createElement( 'div' );

      div.innerHTML = style_template + button_template.replace("{{post_id}}", postId);
      document.body.appendChild( div );
    };

    const getCookie = ( name ) => {
      return document.cookie.split( '; ' ).reduce( ( r, v ) => {
        const parts = v.split( '=' );
        return (
          parts[0] === name
        ) ? decodeURIComponent( parts[1] ) : r;
      }, '' );
    };

    const  was_user_logged_in = () => {
      const ADMIN_ROLES = ['administrator', 'author', 'editor'];
      let admin_cookie = getCookie( 'wp_uwpac' );

      if ( !!admin_cookie && ADMIN_ROLES.indexOf( admin_cookie ) > -1 ) {
          return true; // Der Benutzer war oder ist eingeloggt
      }

      return false; // Der Benutzer ist definitiv nicht eingeloggt
    }

    if ( window.uwpac === undefined || was_user_logged_in() === false ) {
      return;
    }



    fetch( window.uwpac.ajaxurl, {
      method: 'POST', // or 'PUT'
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: 'action=ut_is_user_logged_in'
    } )
      .then( response => response.json() )
      .then( data => {
        if ( data.state !== undefined && data.state === 'yes' ) {
          set_admin_links();
        }
      } );
  }()
);
